import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SERVICES } from "@/lib/services";

let cache = null;

export function useServices() {
  const [services, setServices] = useState(cache || SERVICES);
  useEffect(() => {
    if (cache) return;
    api
      .get("/services")
      .then(({ data }) => {
        if (Array.isArray(data) && data.length) {
          cache = data;
          setServices(data);
        }
      })
      .catch(() => {});
  }, []);
  return services;
}
